import useRouterTabStore from '@/store/modules/routerTab'
/**
 * 初始化Store数据
 */
export const initStore = async () => {
    const routerTabStore = useRouterTabStore()
    routerTabStore.initStore()
}
